exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delivery-refund-info[data-v-9d30485e]{width:100%}.delivery-refund-info td[data-v-9d30485e]{text-align:left;border:1px solid #e0d9d9;padding:10px;vertical-align:middle!important}.delivery-refund-info[data-v-9d30485e]{background-color:#eee}", ""]);

// exports
